import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PricingArea} from '../../data/pricing-area';
import Handsontable from 'handsontable';
import {Subscription} from 'rxjs';
import {ProjectCalcService} from '../../data/project-calc.service';
import {debounceTime} from 'rxjs/operators';
import {ColumnSettings} from 'handsontable/settings';

@Component({
  selector: 'app-formulas-table-sheet',
  templateUrl: './formulas-table-sheet.component.html',
  styleUrls: ['./formulas-table-sheet.component.scss']
})
export class FormulasTableSheetComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input()
  area: PricingArea;

  @Input()
  pricingId: number

  @ViewChild('table')
  tableEl: ElementRef;

  table: Handsontable;

  customTableLoading = true;
  progressBarLoading = true;

  formulaSubj: Subscription;

  constructor(
    private projectCalcService: ProjectCalcService
  ) {
  }

  ngOnInit(): void {
    this.formulaSubj = this.projectCalcService.formulaSubj.pipe(debounceTime(500)).subscribe(areaId => {
      this.fillFormulasData(areaId)
    })

    this.projectCalcService.formulaSubj.next(this.area.id)
  }

  fillFormulasTable() {
    this.table = new Handsontable(this.tableEl.nativeElement, {
      data: [],
      height: 'auto',
      rowHeaders: true,
      rowHeaderWidth: 30,
      colHeaders: ['Name', 'Entree', 'Cost', 'Extended'],
      columns: [
        {data: 'name', type: 'text', readOnly: true},
        {data: 'entree', type: 'numeric', readOnly: true},
        {data: 'cost', type: 'numeric', readOnly: true},
        {data: 'extended', type: 'numeric', readOnly: true}
      ],
      colWidths: [200, 60, 70, 70],
      // manualColumnResize: true,
      licenseKey: 'non-commercial-and-evaluation', // for non-commercial use only
      contextMenu: false,
      afterSelectionEnd: () => {
        this.countSelectedCells()
      }
    });
  }

  fillFormulasData(areaId: number) {
    this.progressBarLoading = true;
    this.projectCalcService.getFormulas(this.pricingId, areaId).subscribe(formulasData => {
      this.table.updateData(formulasData.items)


      this.table.updateSettings({
        cells: (row) => {
          const cellProperties = {
            className: '',
          } as ColumnSettings;

          const fieldName = this.table.getDataAtCell(row, 0);
          if (fieldName && fieldName.includes(':')) {
            cellProperties.className = 'htUpper'
          }

          return cellProperties;
        }
      })
      this.customTableLoading = false;
      this.progressBarLoading = false;
    }, () => {
      this.customTableLoading = false;
      this.progressBarLoading = false;
    })
  }

  countSelectedCells() {
    this.projectCalcService.countSelectedCells(this.table)
  }

  ngAfterViewInit() {
    this.fillFormulasTable()
  }

  ngOnDestroy() {
    if (this.formulaSubj) {
      this.formulaSubj.unsubscribe()
      this.formulaSubj = null;
    }
  }
}
